import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout';

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};
export default new Router({
    routes: [
        {
            path: '/',
            name: 'dashboard',
            component: Layout,
            children: [
                {
                    path: '/addProject',
                    component: () => import('@/views/project/addProject'),
                    name: 'AddProjectMain'
                }
            ]
        },
        {
            path: '/404',
            component: () => import('@/error-page/404'),
            hidden: true
        },
        {
            path: '/project',
            component: Layout,
            alwaysShow: true,
            name: 'project',
            redirect: '/project/addProject',
            hidden: false,
            children: [
                {
                    path: '/project/addProject',
                    component: () => import('@/views/project/addProject'),
                    meta: {
                        title: '试验项目'
                    },
                    name: 'AddProject'
                }
            ]
        },
        {
            path: '/signal',
            component: Layout,
            alwaysShow: true,
            name: 'signal',
            redirect: '/signal/signalPage',
            hidden: false,
            children: [
                {
                    path: '/signal/signalPage',
                    component: () => import('@/views/signal/signalPage'),
                    meta: {
                        title: '信号检查'
                    },
                    name: 'signalPage'
                }
            ]
        },
        {
            path: '/experimentView',
            component: Layout,
            alwaysShow: true,
            name: 'experiment',
            redirect: '/experimentView/experimentView',
            hidden: false,
            children: [
                {
                    path: '/experimentView/experimentView',
                    component: () => import('@/views/experimentView/experimentView'),
                    meta: {
                        title: '试验视图'
                    },
                    name: 'experimentView'
                }
            ]
        },
        {
            path: '/dataManagement',
            component: Layout,
            alwaysShow: true,
            name: 'dataManagement',
            redirect: '/dataManagementView/dataManagementView',
            hidden: false,
            children: [
                {
                    path: '/dataManagementView/dataManagementView',
                    component: () => import('@/views/dataManagementView/dataManagementView'),
                    meta: {
                        title: '数据管理'
                    },
                    name: 'dataManagementView'
                }
            ]
        },
        {
            path: '/comfortCompute',
            component: Layout,
            alwaysShow: true,
            name: 'comfortable',
            redirect: '/comfortComputeView/comfortComputeView',
            hidden: false,
            children: [
                {
                    path: '/comfortComputeView/comfortComputeView',
                    component: () => import('@/views/comfortComputeView/comfortComputeView'),
                    meta: {
                        title: 'CFD舒适性计算'
                    },
                    name: 'comfortComputeView'
                }
            ]
        },
        {
            path: '/dataAnalysis',
            component: Layout,
            alwaysShow: true,
            name: 'dataAnalysis',
            redirect: '/dataAnalysisView/dataAnalysisView',
            hidden: false,
            children: [
                {
                    path: '/dataAnalysisView/dataAnalysisView',
                    component: () => import('@/views/dataAnalysisView/dataAnalysisView'),
                    meta: {
                        title: '数据分析'
                    },
                    name: 'dataAnalysisView'
                }
            ]
        },
        {
            path: '/dataReport',
            component: Layout,
            alwaysShow: true,
            name: 'dataReport',
            redirect: '/dataReport/dataReport',
            hidden: false,
            children: [
                {
                    path: '/dataReport/dataReport',
                    component: () => import('@/views/dataReport/dataReport'),
                    meta: {
                        title: '分析报告'
                    },
                    name: 'dataReportPage'
                }
            ]
        },
        {
            path: '/manData',
            component: Layout,
            alwaysShow: true,
            name: 'ManData',
            redirect: '/manData/manData',
            hidden: false,
            children: [
                {
                    path: '/manData/manData',
                    component: () => import('@/views/manData/manData'),
                    meta: {
                        title: '12'
                    },
                    name: 'ManData'
                }
            ]
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js